import { render, staticRenderFns } from "./IconTerminalSolid.vue?vue&type=template&id=53dd0e73"
import script from "./IconTerminalSolid.vue?vue&type=script&lang=js"
export * from "./IconTerminalSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports